import * as constants from '../constants';

const initialState = false;

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getCalculate.try:
        case constants.updateCalculate.try: {
            return true;
        }

        case constants.getCalculate.success:
        case constants.getCalculate.error:
        case constants.updateCalculate.success:
        case constants.updateCalculate.error: {
            return false;
        }

        default:
            return state;
    }
}